import { useCallback } from 'react';

import type { UpdateInvestorFirmInput } from '../../../../../../graphql';
import {
  useInvestorFirms_AdminUpdateInvestorFirmMutation,
  useInvestorFirms_UpdateInvestorFirmMutation,
} from '../graphql/__generated__';

export function useUpdateInvestorFirm(tenantId?: string) {
  const [updateInvestorFirmAsCustomer, { error: updateInvestorFirmError }] =
    useInvestorFirms_UpdateInvestorFirmMutation();

  const [updateInvestorFirmAsAdmin, { error: updateAdminInvestorFirmError }] =
    useInvestorFirms_AdminUpdateInvestorFirmMutation();

  const updateInvestorFirm = useCallback(
    async (firmKeyOrId: string, input: UpdateInvestorFirmInput) => {
      if (tenantId) {
        await updateInvestorFirmAsAdmin({
          variables: {
            input: {
              firmKeyOrId,
              tenantId,
              input,
            },
          },
        });
      } else {
        await updateInvestorFirmAsCustomer({
          variables: {
            firmKeyOrId,
            input,
          },
        });
      }
    },
    [tenantId, updateInvestorFirmAsAdmin, updateInvestorFirmAsCustomer]
  );

  if (tenantId) {
    return {
      updateInvestorFirm,
      error: updateAdminInvestorFirmError,
    };
  }
  return {
    updateInvestorFirm,
    error: updateInvestorFirmError,
  };
}
